export default
{
  perfil: ['Sobre mim', 'About me', 'Sobre mi'],
  color: ['Coloração pessoal', 'Personal coloring', 'Coloración personal'],
  moodboard: ['Guia de estilo', 'Moodboard', 'Moodboard'],
  closet: ['Closet virtual', 'Virtual closet', 'Armario virtual'],
  list: ['Lista de compras', 'Shopping list', 'Listado de compras'],
  schedule: ['Agenda', 'Schedule', 'Programa'],
  support: ['Contatar suporte', 'Contact support', 'Soporte de contacto'],
  shop: ['Minhas compras', 'My shopping', 'Mis compras'],
  rememberedYou: ['Lembrei de você', 'Remembered you', 'Te recordé'],
  logout: ['Sair', 'Logout', 'Cerrar sesión'],
  home: ['Início', 'Home', 'Comienzo'],
  billings: ['Minhas cobranças', 'My charges', 'Mis cargos']
}



// WEBPACK FOOTER //
// ./src/constants/Menu.js